"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const primary = {
  bg: 'background.default',
  headerBg: 'background.default',
  headerCellBoxShadow: [0, -1, 0, 'ui3', true],
  cellHeight: undefined,
  headerHeight: undefined,
  minWidth: undefined
};
const strike = {
  bg: 'interactive.tan.default',
  headerBg: 'interactive.tan.default',
  headerCellBoxShadow: [0, -1, 0, 'ui3', true],
  cellHeight: 50,
  headerHeight: 40,
  minWidth: 116
};
const optionChain = {
  headerBg: 'background.default',
  headerCellBoxShadow: [0, -1, 0, 'ui3', true],
  bg: 'transparent',
  cellHeight: 50,
  headerHeight: 40,
  minWidth: undefined
};
const theme = {
  optionChain,
  primary,
  strike
};
exports.theme = theme;
//# sourceMappingURL=Table.theme.js.map